var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGi(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 40,
    fill: "none",
    viewBox: "0 0 54 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#da000c",
    d: "M.3 0h53.4v40H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.4v26.8H.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M17.7 18.2h10V25h-10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da000c",
    d: "M23 24h-6.2l-1.3 1v.9h7.4M20.4 20c.8 0 1.6.7 1.6 1.6V24h1v-8.7h-6.2V24h2v-2.3q.1-1.4 1.6-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: 0.2,
    d: "M23 24h-6.2l-1.3 1v.9h7.4M20.4 20c.8 0 1.6.7 1.6 1.6V24h1v-8.7h-6.2V24h2v-2.3q.1-1.4 1.6-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M19 9.4h2.9v5.3h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da000c",
    d: "M21.8 13.9h-2.5v-1h-1.8v1h-1.3v-1h-.8v1.7h6.4m-5.6 0h5.5v.7h-5.5zm2.2-7.2V13h1v-1.5q0-1 .9-1.1a1 1 0 0 1 1 1V13h1V7.4zm-.4-.7v.7h4.6v-.7zm-.6-1.4v1.4H23V5.3h-.8V6h-1v-.7h-1.6V6h-1v-.7zm-2 19.6H23Zm12.4-.4h-5l-1.6.7v1.1h6.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: 0.2,
    d: "M21.8 13.9h-2.5v-1h-1.8v1h-1.3v-1h-.8v1.7h6.4m-6.4 10.3H23m4.9-.4h-5l-1.6.7v1.1h6.6M16.2 14.6h5.5v.7h-5.5zm2.2-7.2V13h1v-1.5q0-1 .9-1.1h0a1 1 0 0 1 1 1V13h1V7.4zm-.4-.7v.7h4.6v-.7zm-.6-1.4v1.4H23V5.3h-.8V6h-1v-.7h-1.6V6h-1v-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da000c",
    d: "M21.2 25.2h6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M21.2 25.2h6.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M36.3 18.2h-10V25h10z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da000c",
    d: "M31 24h6.2l1.3 1v.9h-7.4m2.5-5.8c-.8 0-1.6.7-1.6 1.6V24h-1v-8.7h6.2V24h-2v-2.3q-.1-1.4-1.6-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: 0.2,
    d: "M31 24h6.2l1.3 1v.9h-7.4m2.5-5.8c-.8 0-1.6.7-1.6 1.6V24h-1v-8.7h6.2V24h-2v-2.3q-.1-1.4-1.6-1.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M35 9.4h-2.9v5.3h3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da000c",
    d: "M32.2 13.9h2.5v-1h1.8v1h1.3v-1h.8v1.7h-6.4m5.6 0h-5.5v.7h5.5zm-2.2-7.2V13h-1v-1.5q0-1-.9-1.1a1 1 0 0 0-1 1V13h-1V7.4zm.4-.7v.7h-4.6v-.7zm.6-1.4v1.4H31V5.3h.8V6h1v-.7h1.6V6h1v-.7zm2 19.6H31Zm-12.4-.4h5l1.6.7v1.1h-6.6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "square",
    strokeWidth: 0.2,
    d: "M32.2 13.9h2.5v-1h1.8v1h1.3v-1h.8v1.7h-6.4m6.4 10.3H31m-4.9-.4h5l1.6.7v1.1h-6.6m11.6-11.7h-5.5v.7h5.5zm-2.2-7.2V13h-1v-1.5q0-1-.9-1.1h0a1 1 0 0 0-1 1V13h-1V7.4zm.4-.7v.7h-4.6v-.7zm.6-1.4v1.4H31V5.3h.8V6h1v-.7h1.6V6h1v-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da000c",
    d: "M32.8 25.2h-6.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M32.8 25.2h-6.7"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8d80e",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2,
    d: "m29.7 23.4-1.2.6-1.8 1.3-.3.6.3-.1q.2-.2.4-.1l.7-.5 2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8d80e",
    d: "M27.7 24.6v.6Zm.4-.3v.6Zm.3-.2v.6Zm.4-.2v.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2,
    d: "M27.7 24.6v.6m.4-.9v.6m.3-.8v.6m.4-.8v.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8d80e",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2,
    d: "m24.3 23.5-.2.5q1.3.5 2.5 1.2l.8.6q0 .3-.2.2h-.4q-.4.3 0 .5.6.2 1-.3.3-.4 0-.7l-1.2-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8d80e",
    d: "M26.7 24.7v.5Zm.4.3-.1.5Zm.5.3-.3.4Zm.1 1-.4-.2Zm.2-.5h-.5Zm-.6.7v-.4Zm-.2-.4-.4.2Zm-1.9-2.2v.5Zm1 .5v.6Zm-.5-.2v.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 0.2,
    d: "M26.7 24.7v.5m.4-.2-.1.5m.6-.2-.3.4m.4.6-.4-.2m.6-.3h-.5m-.1.7v-.4m-.2 0-.4.2M25.2 24v.5m1 0v.6m-.5-.8v.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8d80e",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M23.8 35.6v1.2h.8v-.6h1.1v.6h.8v-1.2zm0 1.7v1.2h2.7v-1.2h-.8v.6h-1v-.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8d80e",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M26.5 30.3h.8v9h-.8z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8d80e",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M26.5 31h.8v8h-.8zm.4-3 1.7 1-1.7 1-1.6-1zm-2.2.7h-.4v.6h.4l2.2 1.3 2.3-1.3h.4v-.6h-.4l-2.3-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f8d80e",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M26.9 25.7a1 1 0 0 0-.6.8v1.7a1 1 0 0 0 .7.7l.7-.4-.2-.2-.5.3q-.4 0-.4-.5v-1.7l.4-.4h.3q.1-.2-.1-.3zm.9.6-.3.2v1.2l.3.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000001",
    d: "M24.6 6h4.6v8.3h-4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da000c",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M24.3 6v7h1.5v-2.1c0-.5.3-1.2 1.2-1.2 1 0 1.3.7 1.3 1.2v2h1.4V6zm2.5.8h.4v2.4h-.4zm-1.3.5h.5V9h-.5zm2.6 0h.4V9H28zM23.8 5v1h6.4V5zm-.6-1.2V5h7.6V3.8h-1v.7h-1v-.7h-1.3v.7h-1v-.7h-1.3v.7h-1v-.7zm-1.4 11.5v.7h10.4v-.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da000c",
    stroke: "#000",
    strokeWidth: 0.2,
    d: "M21.4 13v2.3h11.2V13h-1v.9H30v-1h-1.9v1h-2.4v-1h-2v1h-1.4v-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#da000c",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 0.2,
    d: "M22.7 16v8.5h2v-3.2q.2-2.2 2.3-2.2c1.2 0 2.3.7 2.3 2.2v3.2h2V16z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.3 0h53.3v40H.3z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGi);
export default __webpack_public_path__ + "static/media/gi.ad953e7ed06c71bc1b2260fc215339d3.svg";
export { ForwardRef as ReactComponent };